import React from 'react';
import Swal from 'sweetalert2';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { FaRegFileExcel } from 'react-icons/fa';

//Scripts auxiliares:
import { registerAuditProcess } from '../../../tools/scripts/customFetching';

//Estilos base:
const fileContainerStyle = { display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", paddingTop: 10, paddingBottom: 10 };

//Contenidos Swal:
const confirmationContent = {
    title: '<p>@titulo</p>',
    // showClass: { popup: 'animated fadeInDown faster' },
    icon: 'warning',
    html: '<p style="font-size: 0.75em; text-align: center">¿Estás seguro de ejecutar esta operación? @detalle</p>',
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonText:
        'Continuar<i class="fa fa-thumbs-up" style="margin-left: 5px"></i>',
    cancelButtonText:
        'Cancelar<i class="fa fa-thumbs-down" style="margin-left: 5px"></i>',
}

let EquivalencesUpdater = (props) => {
    return (
        <div style={{ overflowX: "hidden" }}>
            {getSourceTitle(props)}

            <div style={{ padding: 0, marginTop: 20 }}>
                {getEquivalencesManager(props)}
            </div>
        </div>
    );
}

const getEquivalencesManager = (props) => {
    if (props.activeDownloadSource && props.activeDownloadSource.require_equivalences) {
        return (
            <div>
                <div style={{ ...fileContainerStyle, minHeight: 50, marginTop: 5, cursor: "pointer" }}
                    onClick={() => {
                        window.open(process.env.REACT_APP_API_URL + "/sources/" + props.activeDownloadSource.id + "/get_preconfig_file", "_blank");
                    }}>
                    
                    <FaRegFileExcel color="var(--success)" style={{ marginRight: 5 }} />
                    
                    <span className="file-hyperlink" style={{ marginTop: 2 }}>
                        {props.activeDownloadSource.equivalences_file_name}
                    </span>
                </div>

                <hr style={{ marginTop: 5, marginBottom: 5 }} />
                <div style={{ textAlign: "right" }}>
                    <Button color="info" style={{ fontSize: 10 }}
                        onClick={() => { 
                            window.document.getElementById("fileInputForEquivalences").click();
                        }} dangerouslySetInnerHTML={{ __html: "Cargar nuevo archivo" }} />

                    <Button color="warning" style={{ fontSize: 10 }}
                        onClick={() => {
                            let detalle = "La fuente <b>" + props.activeDownloadSource.description.replace(":", ": ")
                                + "</b> volverá a su configuración de equivalencias original. Esto no tiene vuelta atrás."

                            let myConfirmationContent = { ...confirmationContent };
                            myConfirmationContent.html = myConfirmationContent.html.replace("@detalle", detalle);
                            myConfirmationContent.title = myConfirmationContent.title.replace("@titulo", "Resetear equivalencia");

                            Swal.fire(myConfirmationContent)
                                .then(result => {
                                    if (result.value) {
                                        fetch(process.env.REACT_APP_API_URL + "/sources/" + props.activeDownloadSource.id + "/reset_preconfig_file/", {
                                            method: "DELETE",
                                            headers: {
                                                "Content-Type": "application/json",
                                                "Authorization": "Token " + props.activeUser.authToken,
                                            },
                                            body: JSON.stringify({})
                                        })
                                            .then((serverResponse) => {
                                                switch(serverResponse.status){
                                                    case 200:
                                                        fireSuccessProcessAlert();

                                                        registerAuditProcess(props, {
                                                            "event_type": "EQUIVALENCES_UPDATE",
                                                            "description": "El usuario reseteó el archivo de equivalencias de <b>"
                                                                + props.activeDownloadSource.description.replace(":", ": ") + "</b>"
                                                        });
                                                        break;

                                                    default:
                                                        fireFailedProcessAlert();
                                                        break;
                                                }
                                            })
                                            .catch(error => {
                                                console.log(error);
                                            });
                                    }
                                });
                        }} dangerouslySetInnerHTML={{ __html: "Volver al default" }} />
                </div>

                <input id="fileInputForEquivalences" type="file" style={{ display: "none" }}
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    onChange={(e) => { 
                        let newFile = e.target.files[0];
                        let detalle = "Las próximas descargas de la fuente <b>" + props.activeDownloadSource.description.replace(":", ": ")
                            + "</b>, utilizarán las equivalencias del fichero <i>" + newFile.name + "</i>. En cualquier momento podrás resetear la configuración.";

                        let myConfirmationContent = { ...confirmationContent };
                        myConfirmationContent.html = myConfirmationContent.html.replace("@detalle", detalle);
                        myConfirmationContent.title = myConfirmationContent.title.replace("@titulo", "Parametrizar equivalencia");

                        Swal.fire(myConfirmationContent)
                            .then(result => {
                                if (result.value) {
                                    window.document.getElementById("fileInputForEquivalences").value = "";
                                    
                                    const data = new FormData();
                                    data.append("file", newFile);

                                    fetch(process.env.REACT_APP_API_URL + "/sources/" + props.activeDownloadSource.id + "/update_preconfig_file/", {
                                        method: "PUT",
                                        headers: {
                                            "Content-Disposition": "attachment; filename=" + newFile.name,
                                            "Authorization": "Token " + props.activeUser.authToken,
                                        },
                                        body: data
                                    })
                                        .then((serverResponse) => {
                                            switch (serverResponse.status) {
                                                case 200:
                                                    fireSuccessProcessAlert();
                                                    registerAuditProcess(props, {
                                                        "event_type": "EQUIVALENCES_UPDATE",
                                                        "description": "El usuario configuró el archivo de equivalencias de <b>"
                                                            + props.activeDownloadSource.description.replace(":", ": ") + "</b>"
                                                    });
                                                    break;

                                                default:
                                                    serverResponse.json()
                                                        .then(data => { console.log(data); });

                                                    fireFailedProcessAlert();
                                                    break;
                                            }
                                        })
                                        .catch(error => {
                                            console.log(error);
                                        });
                                }
                            });
                    }}
                />
            </div>
        );
    }
    else {
        return (
            <p style={{ fontSize: 11, textAlign: "left" }}>
                Esta fuente no requiere fichero de preconfiguración de equivalencias
            </p>
        )
    }
}

const getSourceTitle = (props) => {
    if (props.activeDownloadSource && props.activeDownloadSource.description !== undefined) {
        let mainWord = props.activeDownloadSource.description.split(":")[0];
        let secondaryWord = props.activeDownloadSource.description.split(":")[1];

        let title = mainWord;
        if (secondaryWord) { title += ": <b>" + secondaryWord + "</b>" }
        else { title = "<b>" + title + "</b>"; }

        return (
            <React.Fragment>
                <p style={{ fontSize: 11, marginBottom: 0, textTransform: "uppercase" }}
                    dangerouslySetInnerHTML={{ __html: title }} />

                <p style={{ fontSize: 9, marginBottom: 0, textTransform: "uppercase" }}
                    dangerouslySetInnerHTML={{ __html: "Preconfiguración de equivalencias" }} />
            </React.Fragment>
        );
    }
}

//Swals
const fireFailedProcessAlert = () => {
    Swal.fire('', 'El proceso falló', 'error');
}

const fireSuccessProcessAlert = () => {
    Swal.fire('', 'El proceso se <b>completó con éxito</b>', 'success');
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        enableAuditRegistering: state.mainReducer.enableAuditRegistering,
    };
};

export default connect(mapStateToProps)(EquivalencesUpdater);